import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiDateRangeCalendar = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      // Calendar Header Styles
      "& .MuiPickersArrowSwitcher-root": {
        color: theme.palette.text.secondary,
        "& .MuiTypography-root": {
          fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
          fontSize: capitalDesignTokens.foundations.typography.fontSize.h4
        },
        button: {
          color: "inherit"
        }
      },
      "& button.Mui-disabled": {
        color: theme.palette.text.disabled,
        opacity: 0.4
      },
      "& .MuiPickersSlideTransition-root": {
        marginBottom: theme.spacing(1)
      },
      "& .MuiDateRangeCalendar-monthContainer": {
        "&:not(:last-of-type)": {
          borderRight: "none",
          position: "relative",
          // Vertical line on the right side
          "&::after": {
            content: '""',
            position: "absolute",
            top: theme.spacing(3),
            bottom: theme.spacing(3),
            right: 0,
            width: "1px",
            backgroundColor: theme.palette.divider
          }
        }
      }
    })
  }
};
export {
  MuiDateRangeCalendar
};
//# sourceMappingURL=MuiDateRangeCalendar.js.map
